import {iExtraInfo, iList} from "../../../../../../shared/interfaces";

export const objectFieldDiff = (list: iList<iExtraInfo>, labels: iList<string>) => {
    const extraInfoArray = Object.values(list).map((val) => val.details.name).filter(name => labels[name] === undefined);
    return extraInfoArray;
}